module.exports = __webpack_public_path__ + "img/empty-graph.5e551db4.svg";